import SageScreen from "kit/SageScreen";
import React from "react";
import { Button } from "react-bootstrap";
import CreateTeamDialog from "./teams/CreateTeamDialog";
import TeamsInvite from "./teams/TeamsInvite";
import TeamsMember from "./teams/TeamsMember";

const Teams: React.FC = () => {
    return (
        <>
            <CreateTeamDialog />
            <SageScreen>
                <div className="row align-items-center">
                    <div className="col">
                        <h1>
                            Teams{" "}
                            <Button
                                data-toggle="modal"
                                data-target="#createTeamModal"
                                size="sm"
                            >
                                Create New Team
                            </Button>
                        </h1>
                    </div>
                </div>
                <div>
                    <p>
                        These are the teams that you are invited to and the
                        teams that you are apart of. When you select private
                        mode on your renders, only those on the team you select
                        can render your job and the job will not cost anything.
                    </p>
                </div>
                <TeamsInvite />
                <TeamsMember />
            </SageScreen>
        </>
    );
};

export default Teams;
